export default "__VITE_ASSET__CL52X9Iz__"